import React from 'react'
import HeroSectionComponents from '../../components/Hero Section Components/HeroSectionComponents'
import ContentPrivacyPolicy from './ContentPrivacyPolicy'

export default function PrivacyPolicy() {
    return (
        <>
            <HeroSectionComponents />
            <ContentPrivacyPolicy />
        </>
    )
}
